import * as Types from 'src/actions/default-profile/change/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { getUser } from 'src/actions/user/get/GetUser.actions';

export interface ChangeDefaultProfileAttempt extends Action {
  type: Types.CHANGE_DEFAULT_PROFILE_ATTEMPT;
}

export interface ChangeDefaultProfileSuccess extends Action {
  type: Types.CHANGE_DEFAULT_PROFILE_SUCCESS;
}

export interface ChangeDefaultProfileFailure extends Action {
  type: Types.CHANGE_DEFAULT_PROFILE_FAILURE;
  payload: {};
}

export type ChangeDefaultProfileAction =
  ChangeDefaultProfileAttempt | ChangeDefaultProfileSuccess | ChangeDefaultProfileFailure;

export interface ChangeDefaultProfileThunk extends ThunkAction<Promise<ChangeDefaultProfileAction>, RootState, null> {
}

export const changeDefaultProfileAttempt: ActionCreator<ChangeDefaultProfileAttempt> = () => (
  {
    type: Types.CHANGE_DEFAULT_PROFILE_ATTEMPT,
  }
);

export const changeDefaultProfileSuccess: ActionCreator<ChangeDefaultProfileSuccess> = () => (
  {
    type: Types.CHANGE_DEFAULT_PROFILE_SUCCESS,
  }
);

export const changeDefaultProfileFailure: ActionCreator<ChangeDefaultProfileFailure> = (error: {}) => (
  {
    type: Types.CHANGE_DEFAULT_PROFILE_FAILURE,
    payload: error
  }
);

export const changeDefaultProfile: ActionCreator<ChangeDefaultProfileThunk> = (
  userId: number,
  id: string,
  personType: string,
): ChangeDefaultProfileThunk => {
  return (dispatch: Dispatch<RootState>): Promise<ChangeDefaultProfileAction> => {
    dispatch(changeDefaultProfileAttempt());

    return ApiClient.user.updateDefaultProfile(userId, id, personType)
      .then((response: AxiosResponse): ChangeDefaultProfileSuccess => {

        dispatch(getUser(userId));
        return dispatch(changeDefaultProfileSuccess());
      }).catch((e: { response: { data: { errors: {} } } }): ChangeDefaultProfileFailure => {
        const errors = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.errors);

        return dispatch(changeDefaultProfileFailure(errors));
      });
  };
};


// WEBPACK FOOTER //
// ./src/actions/default-profile/change/ChangeDefaultProfile.actions.tsx